import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es6.set.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.fill.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.promise.js";
import PropTypes from 'prop-types';
export default function createRenderPromises() {
  var isomorphicState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var clients = new Set(); // add a client encountered in the react-tree
  // and bootstrap its state when isomorphicState is supplied

  function addClient(client) {
    // early return if client already in Set
    if (clients.has(client)) return; // clients are added in deterministic order, so
    // when client-side isomorphicState is supplied,
    // prefill each dataProviders in tree with their matching
    // data state from the server

    var ssrState = isomorphicState[clients.size];

    if (ssrState) {
      var dataProviders = client.dataProviders;
      dataProviders.fill(ssrState);
    } // add this client from the react tree to the clients Set


    clients.add(client);
  } // extract each dataProviders state in the order they were added to the react tree
  // the output of this method should be transferred from server to browser
  // and when calling `createClient(...)` in the browser-bundle


  function extract() {
    return _toConsumableArray(clients).map(function (_ref) {
      var dataProviders = _ref.dataProviders;
      return dataProviders.extract();
    });
  } // check if any asynchronous StructuredContent render operations
  // remain unfulfilled


  function hasPending() {
    var pending = false;
    clients.forEach(function (client) {
      var componentsStore = client.componentsStore,
          dataProviders = client.dataProviders;

      if (componentsStore.hasPending() || dataProviders.hasPending()) {
        pending = true;
      }
    });
    return pending;
  } // wait for fulfillment of all outstanding promises created during a StructuredContent render


  function waitForPending() {
    return _waitForPending.apply(this, arguments);
  }

  function _waitForPending() {
    _waitForPending = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var waits;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              waits = _toConsumableArray(clients).map(function (_ref2) {
                var componentsStore = _ref2.componentsStore,
                    dataProviders = _ref2.dataProviders;
                return Promise.all([componentsStore.waitForPending(), dataProviders.waitForPending()]);
              });
              _context.next = 3;
              return Promise.all(waits);

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _waitForPending.apply(this, arguments);
  }

  return {
    addClient: addClient,
    extract: extract,
    hasPending: hasPending,
    waitForPending: waitForPending
  };
}
export var propType = PropTypes.shape({
  addClient: PropTypes.func.isRequired,
  extract: PropTypes.func.isRequired,
  hasPending: PropTypes.func.isRequired,
  waitForPending: PropTypes.func.isRequired
});